import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "senf-shared";
import type { Project } from "senf-shared/types";
import { cn } from "../../../util/classNameConstructor";
import Button from "../../core/button/Button";
import Icon from "../../core/icon/Icon";
import Seperator from "../../core/seperator/Seperator";
import LabelledSwitch from "../../core/switch/LabelledSwitch";
import { useModals } from "../../molecules/modalStack/ModalProvider";
import i18n from "senf-shared/utils/i18n";

export const Checkmark = ({ checked, className = "" }) => {
  if (!checked) return null;
  return (
    <div
      className={cn(
        "flex items-center justify-center h-5 w-5 bg-action-primary-default rounded-full",
        className,
      )}
    >
      <Icon name={"checkmark-md"} className="text-text-on-primary" />
    </div>
  );
};

const AccessibilityModal = ({ withSimpleLanguage }: { withSimpleLanguage: boolean }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 px-5">
      <div className="flex gap-3 items-center">
        <Checkmark checked />{" "}
        {t("accessibility:accessibilitySettings.largerText")}
      </div>
     {withSimpleLanguage && <div className="flex gap-3 items-center">
        <Checkmark checked />{" "}
        {t("accessibility:accessibilitySettings.simpleLanguage")}
      </div>}
      <div className="flex gap-3 items-center">
        <Checkmark checked /> {t("accessibility:accessibilitySettings.tts")}
      </div>
    </div>
  );
};
const AccessibilitySettings = ({
  project,
  size,
  variant,
}: {
  project: Project;
  size?: "sm" | "md" | "lg";
  variant?: "outline" | "basic";
}) => {
  const { t } = useTranslation();
  const [accessibility, setAccessibility] = useGlobalState().accessibilityState;
  const { openModal } = useModals();

  return (
    <Button
      onClick={() => {
        if (accessibility) {
          setAccessibility(false);
          localStorage.removeItem("accessibility");
        } else {
          setAccessibility(true);
          localStorage.setItem("accessibility", "true");

          openModal(<AccessibilityModal withSimpleLanguage={project?.settings?.originalLanguage === i18n?.resolvedLanguage} />, {
            title: t("accessibility:accessibilitySettings.title"),
            // description: t("accessibility:accessbilitySettings.description"),
            submitText: t("global:done"),
            zIndex: 9999,
            id: "accessibilitySettings",
          });
        }
      }}
      className={!accessibility && variant !== "basic" ? "bg-white" : ""}
      size={size}
      variant={accessibility ? "primary" : variant || "outline"}
      leadingIcon="accessibility-lg"
      tooltipLabel={t("accessibility:accessibilitySettings.title")}
    />
  );
};

export default AccessibilitySettings;
